import { createContext, useContext } from 'react';

const SessionContext = createContext(null);

export function SessionProvider({ value, children }) {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

/**
 * @returns {any} the session bucket.
 *
 * Untyped on purpose, and annotated so it stays usable from TypeScript:
 * `createContext(null)` plus a throw-guard narrows the return to `never`,
 * so a .tsx consumer gets "Property 'x' does not exist on type 'never'".
 */
export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used within a SessionProvider');
  return ctx;
}

export default SessionContext;
